import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { getOtpRequest, verifyOtpRequest } from "../../common/features/auth/AuthActions";
import { getCustomerOffersRequest } from "../../common/features/cart/cartActions";
import { ReactComponent as CancelIcon } from "../../common/assets/svg/cancelIconnew.svg";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { ACCESS_TOKEN, USER_DETAILS, USER_ID, SESSION_ERROR_SHOWN, SERVERKNOWNSALT } from "../../common/constants";
import { storeSelectedIngredientChecklist, storeToggleStatus } from "../../common/features/restaurant/restaurantAction";
import { setUserDetails } from "../../common/features/user/userActions";
import { getCookie, setCookie, deleteCookie } from "../../helper/cookieHelper";
import { setSignupPopup } from "../../common/features/navigation/navigationActions";
import { removeauthInfo } from "../../common/features/auth/AuthActions";
import { Store } from "../../common/configureStore";
import { showErrorToast, showErrorToastDesktop } from "../../common/utils/toastUtils";
import { resetSessionErrorFlag } from "../../common/Api";
import { getContactlessDineinLandingPage } from "../../common/utils/route-util";

// const AUTO_OTP_LENGTH = 4;
const OtpScreenNew = ({
  onClose,
  setCurrentPage,
  userData,
  isMobile,
  signInPopupDesktop,
  countryData,
  data,
  handleVerifySubmit,
  onVerifyOtpSubmit,
  onResendOtpSubmit,
  otpTargetType,
  otpDisplayValue,
  onChangeOtpTarget,
  hideChangeOption,
  verifyButtonText,
  verificationLoading,
  verificationFailed,
  verificationErrorMessage,
  profileEmailOtpPopup,
}: any) => {
  const dispatch = useDispatch()
  // const userCountry = useSelector((state: any) => state.auth?.countryCode);
  const verifyOtpSuccess = useSelector((state: any) => state.auth.verifyOtpSuccess);
  const verifyOtpMessage = useSelector((state: any) => state.auth.verifyOtpMessage);
  const verifyOtpLoading = useSelector((state: any) => state.auth.verifyOtpLoading);
  const verifyOtpFailure = useSelector(
    (state: any) => state.auth.verifyOtpFailure
  );

  const otpExceed = useSelector(
    (state: any) => state.auth.getOtpMessage
  );
  const isOtpRateLimitExceeded = useSelector(
    (state: any) => Boolean(state.auth.rateLimitExceeds)
  );

  // Customer-offers fetch state — we defer closing the popup until this
  // settles so the cart renders with eligible coupons already applied.
  const customerOffersLoading = useSelector(
    (state: any) => state.cart?.customerOffersLoading
  );
  const customerOffersSuccess = useSelector(
    (state: any) => state.cart?.customerOffersSuccess
  );
  const customerOffersFailure = useSelector(
    (state: any) => state.cart?.customerOffersFailure
  );
  const [awaitingOffersClose, setAwaitingOffersClose] = useState(false);
  const offersCloseTimeoutRef = useRef<any>(null);

  const OTP_LENGTH = 6;

  const navigate = useNavigate();
  const { merchantType, merchantSlug, tableId, menuType } = useParams()
  const restaurantDetails = useSelector((state: any) => state.restaurant.currentRestaurantDetail);

  const handleChangeOtpTargetClick = () => {
    if (onChangeOtpTarget) {
      onChangeOtpTarget();
      return;
    }

    const isCdFlow = Boolean(localStorage.getItem("CDUSER"));
    if (isCdFlow) {
      const slugFromLocalStorage = (() => {
        try {
          return JSON.parse(localStorage.getItem("restaurant") || "{}");
        } catch {
          return {};
        }
      })();
      const merchantTypeForLanding = merchantType || slugFromLocalStorage?.merchantType;
      const merchantSlugForLanding = merchantSlug || slugFromLocalStorage?.location;
      const tableIdForLanding = tableId || localStorage.getItem("CHECKIN_TABLE_ID");
      const menuTypeForLanding = menuType || slugFromLocalStorage?.menuType;

      if (
        merchantTypeForLanding &&
        merchantSlugForLanding &&
        tableIdForLanding &&
        menuTypeForLanding
      ) {
        navigate(
          getContactlessDineinLandingPage(
            merchantTypeForLanding,
            merchantSlugForLanding,
            tableIdForLanding,
            menuTypeForLanding
          )
        );
        onClose?.(true);
        return;
      }
    }

    setCurrentPage("signin");
  };
  const isEmailOtpFlow =
    otpTargetType === 'email'
      ? true
      : otpTargetType === 'mobile'
        ? false
        : Boolean(restaurantDetails?.platformConfiguration?.sendOtpViaEmail);
  const resolvedOtpDisplayValue =
    otpDisplayValue ||
    data?.inputData ||
    (isEmailOtpFlow ? userData?.email : userData?.mobilePhone) ||
    '';
  const isProfileEmailOtpPopup = Boolean(profileEmailOtpPopup);
  const otpCardClassName = (isMobile ? "otp-card" : "otp-card-D") + (isProfileEmailOtpPopup ? " profile-email-otp-card" : "");
  const isOtpVerificationLoading =
    typeof verificationLoading === 'boolean' ? verificationLoading : verifyOtpLoading;
  const coerceOtpErrorMessage = (value: any): string => {
    if (typeof value === 'string') {
      const normalizedValue = value.trim();
      return /^Request failed with status code \d+$/i.test(normalizedValue) ? '' : normalizedValue;
    }

    if (!value) {
      return '';
    }

    return (
      coerceOtpErrorMessage(value?.message) ||
      coerceOtpErrorMessage(value?.responseMessage) ||
      coerceOtpErrorMessage(value?.metaDataInfo?.responseMessage) ||
      coerceOtpErrorMessage(value?.data) ||
      coerceOtpErrorMessage(value?.body)
    );
  };
  const hasOtpAttemptLimit = isOtpRateLimitExceeded || otpExceed?.httpStatus === 429;
  const otpAttemptLimitMessage =
    coerceOtpErrorMessage(otpExceed) || 'Too many attempts, please try again later';
  const otpFailureText =
    coerceOtpErrorMessage(verificationErrorMessage) ||
    ((typeof verificationFailed === 'boolean' ? verificationFailed : Boolean(verifyOtpFailure))
      ? 'Please enter valid otp'
      : '');
  const [otp, setOtp] = useState<string[]>(new Array(OTP_LENGTH).fill(""));
  const hasCompletedOtp = otp.every((item) => item !== "");
  const hasProfileVerificationError = Boolean(
    coerceOtpErrorMessage(verificationErrorMessage) ||
    (typeof verificationFailed === 'boolean' ? verificationFailed : Boolean(verifyOtpFailure))
  );
  const inlineOtpErrorText =
    isProfileEmailOtpPopup && hasOtpAttemptLimit ? otpAttemptLimitMessage : otpFailureText;
  const shouldShowInlineOtpError = Boolean(
    isProfileEmailOtpPopup
      ? inlineOtpErrorText && (!hasProfileVerificationError || hasCompletedOtp)
      : !hasOtpAttemptLimit && otpFailureText
  );
  const isMobileProfileEmailOtpPopup = isMobile && isProfileEmailOtpPopup;
  const otpContainerClassName = `${isMobile ? "otp-container" : signInPopupDesktop ? "otp-container-D" : "otp-container-D-checkout"}${isMobileProfileEmailOtpPopup ? ` profile-email-otp-container-mobile${shouldShowInlineOtpError ? " has-inline-error" : ""}` : ""}`;
  const mobileCloseButtonClassName = `close-btnZa-otpScreen close-mobile-view${isProfileEmailOtpPopup ? " profile-email-otp-close-mobile" : ""}${isMobileProfileEmailOtpPopup && shouldShowInlineOtpError ? " has-inline-error" : ""}`;
  const feedbackClassName = isProfileEmailOtpPopup
    ? `profile-email-otp-feedback${shouldShowInlineOtpError ? " has-inline-error" : ""}${isMobileProfileEmailOtpPopup ? " profile-email-otp-feedback-mobile" : ""}`
    : "";
  const resendClassName = `Resend-container-otp${isProfileEmailOtpPopup ? " profile-email-otp-resend" : ""}${isMobileProfileEmailOtpPopup ? " profile-email-otp-resend-mobile" : ""}`;
  const [timer, setTimer] = useState(0);
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const handleOtpComplete = (otp: string) => {
  };

  useEffect(() => {
    if ('OTPCredential' in window) {
      const ac = new AbortController();
      navigator.credentials
        .get({
          otp: { transport: ['sms'] },
          signal: ac.signal,
        } as any)
        .then((otp) => {
          if (otp) {
            setOtp(otp.toString().split(""));
          }
          ac.abort();
        })
        .catch((err) => {
          ac.abort();
          console.error(err);
        });
    }
  }, []);


  const startTimer = () => {
    setTimer(180);
    // setIsResendDisabled(true);

    if (timerRef.current) clearInterval(timerRef.current);

    timerRef.current = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current as NodeJS.Timeout);
          setIsResendDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    startTimer();
    return () => clearInterval(timerRef.current as NodeJS.Timeout);
  }, []);

  if (inputRefs.current.length !== OTP_LENGTH) {
    inputRefs.current = Array(OTP_LENGTH).fill(null);
  }

  const handleChange = (index: number, value: string) => {
    // Handle paste - if value length > 1, it's likely a paste operation
    if (value.length > 1) {
      const numericValue = value.replace(/\D/g, '').slice(0, OTP_LENGTH);
      const newOtp = [...otp];
      
      numericValue.split('').forEach((char, i) => {
        if (index + i < OTP_LENGTH) {
          newOtp[index + i] = char;
        }
      });
      
      setOtp(newOtp);
      
      // Focus the next empty input or the last filled input
      const nextIndex = Math.min(index + numericValue.length, OTP_LENGTH - 1);
      setTimeout(() => {
        inputRefs.current[nextIndex]?.focus();
      }, 0);
      
      const otpValue = newOtp.join("");
      if (otpValue.length === OTP_LENGTH && handleOtpComplete) {
        handleOtpComplete(otpValue);
      }
      return;
    }

    // Handle single character input
    if (isNaN(Number(value))) return;
    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);

    // Move to next input if value is entered
    if (value && index < OTP_LENGTH - 1) {
      inputRefs.current[index + 1]?.focus();
    }

    // Check if OTP is complete
    const otpValue = newOtp.join("");
    if (otpValue.length === OTP_LENGTH && handleOtpComplete) {
      handleOtpComplete(otpValue);
    }
  };

  const handleKeyDown = (index: number, e: any) => {
    if (e.key === "Tab") {
      e.preventDefault();
      return;
    }
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      // Move to previous input on backspace if current input is empty
      inputRefs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const clipboardData = e.clipboardData || (window as any)?.clipboardData;
    const pastedData = clipboardData
      ?.getData("text")
      ?.trim()
      .replace(/\D/g, "")
      .slice(0, OTP_LENGTH);

    if (!pastedData || pastedData.length === 0) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const newOtp = [...otp];
    pastedData.split("").forEach((value: string, index: number) => {
      if (index < OTP_LENGTH) {
        newOtp[index] = value;
      }
    });

    setOtp(newOtp);
    
    // Focus the next empty input or the last filled input
    const nextIndex = Math.min(pastedData.length, OTP_LENGTH - 1);
    setTimeout(() => {
      inputRefs.current[nextIndex]?.focus();
    }, 0);
  };

const handleverifyOtp = (e: React.FormEvent) => {
  e.preventDefault();

  if (onVerifyOtpSubmit) {
    onVerifyOtpSubmit(otp.join(''));
    return;
  }

  const mobileOtpDetails = {
    mobilePhone: userData.mobilePhone || '',
    otp: otp.join(''),
    sendOtpViaEmail: false,
  } as any;

  const emailOtpDetails = {
    email: userData?.email || '',
    otp: otp.join(''),
    sendOtpViaEmail: true,
  } as any;

  const userDetails = getCookie(USER_DETAILS) || {};

  if (userData.mobilePhone) {
    userDetails.mobilePhone = userData.mobilePhone;
    setCookie(USER_DETAILS, userDetails);
  }

  // Clear previous identity context before creating a new authenticated session.
  deleteCookie(USER_ID);
  deleteCookie(USER_DETAILS);
  deleteCookie(ACCESS_TOKEN);
  deleteCookie(SERVERKNOWNSALT);
  dispatch(verifyOtpRequest(isEmailOtpFlow ? emailOtpDetails : mobileOtpDetails));
};

  const handleSubmit = (e: React.ChangeEvent<HTMLInputElement>) => {
    const opt = e.target.value?.split("");
    setOtp(otp);
    if (otp.join("").length === OTP_LENGTH && !isOtpVerificationLoading) {
      handleverifyOtp(e);
    }
  }
  // Kick off the customer-offers fetch, then defer closing the popup until it
  // settles — so the cart opens with eligible coupons already applied. Closes
  // immediately if there's nothing to query against, and a safety timeout
  // guarantees we never trap the user if the call hangs.
  const fetchOffersThenClose = () => {
    const locId = restaurantDetails?.id;
    if (!locId ) {
      onClose();
      return;
    }
    dispatch(
      getCustomerOffersRequest({
        locationId: String(locId),
      })
    );
    setAwaitingOffersClose(true);
    if (offersCloseTimeoutRef.current) clearTimeout(offersCloseTimeoutRef.current);
    offersCloseTimeoutRef.current = setTimeout(() => {
      setAwaitingOffersClose(false);
      onClose();
    }, 6000);
  };

  // Close once the deferred offers fetch settles (success OR failure). The
  // REQUEST reducer flips loading=true synchronously on dispatch, so a stale
  // prior success can't close us early.
  useEffect(() => {
    if (!awaitingOffersClose) return;
    if (!customerOffersLoading && (customerOffersSuccess || customerOffersFailure)) {
      if (offersCloseTimeoutRef.current) clearTimeout(offersCloseTimeoutRef.current);
      setAwaitingOffersClose(false);
      onClose();
    }
  }, [awaitingOffersClose, customerOffersLoading, customerOffersSuccess, customerOffersFailure]);

  useEffect(
    () => () => {
      if (offersCloseTimeoutRef.current) clearTimeout(offersCloseTimeoutRef.current);
    },
    []
  );

  useEffect(() => {
    if (onVerifyOtpSubmit) {
      return;
    }

    if (verifyOtpSuccess) {
      // Reset session error flag on successful login
      resetSessionErrorFlag();
      
      // Clear global menu filters/toggles only after successful OTP verification
      try {
        dispatch(
          storeToggleStatus({ onlyAvailable: true, nonVegetarian: false, vegetarian: false })
        );
        dispatch(storeSelectedIngredientChecklist([]));
      } catch {}

      const isProfileComplete = Boolean(
        verifyOtpMessage?.mobilePhone &&
          (verifyOtpMessage?.firstName || verifyOtpMessage?.name) &&
          verifyOtpMessage?.email
      );
      if (!isProfileComplete) {
        setCurrentPage("EditProfile");
        return;
      }

      if (verifyOtpMessage?.customerId) {
        setCookie(USER_ID, verifyOtpMessage?.customerId);
        // localStorage.setItem(USER_DETAILS, JSON.stringify(verifyOtpMessage))
        // localStorage.setItem(USER_ID, verifyOtpMessage?.customerId)
        setCookie(USER_DETAILS, verifyOtpMessage);
        // Fetch this customer's offers before closing so the cart shows
        // applied coupons the moment it opens.
        fetchOffersThenClose();
        // Keep Redux user.userDetails in sync with the freshly-written cookie.
        // Without this, state.user.userDetails is only populated once from the
        // cookie on app mount (Routers.tsx), so after an in-session logout +
        // login as a different user it stays stale (the previous user) until a
        // page refresh — surfacing as the old name on the Rewards page.
        dispatch(setUserDetails(verifyOtpMessage));
        onClose();
      } else {
        setCurrentPage("EditProfile")
      }
    }
  }, [onVerifyOtpSubmit, verifyOtpSuccess, verifyOtpMessage])

  const handleResendOtp = () => {
    setTimer(16);
    setIsResendDisabled(true);

    if (onResendOtpSubmit) {
      onResendOtpSubmit();
      startTimer();
      return;
    }

    dispatch(getOtpRequest(!isEmailOtpFlow ? {
      mobilePhone: countryData?.code + "-" + (data?.inputData || userData?.mobilePhone || ""),
      sendOtpViaEmail: false
    } : {
      email: userData?.email || "",
      sendOtpViaEmail: true
    }));

    startTimer();
  };

  useEffect(() => {
    if (timer === 0) {
      setIsResendDisabled(false);
    } else {
      setIsResendDisabled(true);
    }
  }, [timer]);

  const otpIntroContent = isProfileEmailOtpPopup ? (
    <div className="profile-email-otp-copy">
      <h1 className="profile-email-otp-title">Update Email Address</h1>
      <p className="profile-email-otp-description">
        To securely update your email, a one-time verification code (OTP) will be sent to your registered phone number to confirm this email change.
      </p>
      <p className="profile-email-otp-prompt">
        Please enter OTP sent to <span className="profile-email-otp-phone">{resolvedOtpDisplayValue}</span>
      </p>
    </div>
  ) : (
    <>
      {(isMobile || signInPopupDesktop) && <h1 className="otp-title">Enter OTP</h1>}

      <div className={isMobile ? "otp-subtitle" : signInPopupDesktop ? "otp-subtitle-D-popup" : "otp-subtitle-D"} >
        <span className={isMobile ? "otp-subtitle-text" : signInPopupDesktop ? "otp-subtitle-text-D-popup" : "otp-subtitle-text-D"}>
          We send a one-time password to this {isEmailOtpFlow ? "email id" : "mobile number"}
        </span>
        < div className="mobile-view">
          <span
            className={isMobile ? "otp-subtitle-text-phoneNumber" : "otp-subtitle-text-phoneNumber-D"}
            style={{ color: "#E31837" }}
          >
            {resolvedOtpDisplayValue}
          </span>
          {!hideChangeOption && (
            <span
            className={isMobile ? "otp-subtitle-text-change" : "otp-subtitle-text-change-D"}
            onClick={handleChangeOtpTargetClick}
          >
            Change
            </span>
          )}
        </div>


        <p className="otp-desktop-numberChange-D desktop-view">
          <span
            className={isMobile ? "otp-subtitle-text-phoneNumber" : "otp-subtitle-text-phoneNumber-D"}
            style={{ color: "#E31837" }}
          >
            {resolvedOtpDisplayValue}
          </span>
          {!hideChangeOption && (
            <span
            className={isMobile ? "otp-subtitle-text-change" : "otp-subtitle-text-change-D"}
            onClick={handleChangeOtpTargetClick}
          >
            Change
            </span>
          )}
        </p>

      </div>
    </>
  );

  return (
    <>
      {
        isMobile && <button className={mobileCloseButtonClassName} onClick={() => onClose(true)}>
          {/* <img src={cancelIcon} alt="" /> */}
          <CancelIcon
            className="signInCancel-btn"
            onClick={() => onClose()}
          />
        </button>
      }


      <div className={otpContainerClassName}>
        <div className={otpCardClassName}>
          {otpIntroContent}

          <form>
            <div className={isMobile ? "form-group-otp" : signInPopupDesktop ? "form-group-otp-D-popup" : "form-group-otp"}>

              {/* Hidden single input targeted by mobile OS autofill. Important: keep in DOM, don't use display:none. Using opacity:0 and small size
                makes it visible to autofill while not intrusive. */}

              <input type="text"
                inputMode="numeric"
                autoComplete="one-time-code"
                pattern={`\\d{${OTP_LENGTH}}`}
                maxLength={OTP_LENGTH}
                onChange={handleSubmit}
                style={{ position: "absolute", left: 0, top: 0, width: "1px", height: "1px", padding: 0, border: 0, margin: 0, opacity: 0, zIndex: -1, }}
                aria-hidden="true"
                value={otp?.join("")} />

              {otp.map((value, index) => (
                <input
                  key={index}
                  type="tel"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength={index === 0 ? OTP_LENGTH : 1}
                  value={value}
                  tabIndex={-1}
                  ref={(ref) => {
                    inputRefs.current[index] = ref;
                  }}
                  onChange={(e) => handleChange(index, e.target.value)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                  onPaste={handlePaste}
                  className="otp-input"
                  autoComplete="off"
                />
              ))}
            </div>
            <div className={feedbackClassName}>
              {shouldShowInlineOtpError && (
                <div className={`error-message otp-error${isProfileEmailOtpPopup ? " profile-email-otp-error" : ""}`}>{inlineOtpErrorText}</div>
              )}
            </div>
            {
              !hasOtpAttemptLimit &&
              <div
                className={resendClassName}
                style={{ cursor: isResendDisabled ? "not-allowed" : "pointer" }}
              >
                <button
                  onClick={handleResendOtp}
                  type="button"
                  disabled={isResendDisabled}
                >
                  <span
                    className={!isResendDisabled ? "Resendotp-text cursror" : ""}
                  >Resend OTP </span>
                  <span
                    style={{ color: 'black' }}
                  >
                    {timer > 0 && "in"}
                  </span>
                  <span
                    style={{
                      color: "#E31837",
                      marginLeft: "5px",
                      fontWeight: "600",
                      fontFamily: "Outfit",
                    }}
                  >
                    {timer > 0
                      ? ` ${String(Math.floor(timer / 60)).padStart(2, '0')}:${String(timer % 60).padStart(2, '0')}`
                      : ""}
                  </span>
                </button>
              </div>
            }

            <div className="otp-button-container">

              <button
                type="submit"
                disabled={isOtpVerificationLoading || otp?.some((item) => item === "") || hasOtpAttemptLimit}
                className={`${isMobile ? "otp-button" : signInPopupDesktop ? "otp-button-Desktop-D-popup" : "otp-button-Desktop"} ${(otp?.every((item) => item !== "") && !hasOtpAttemptLimit) ? "" : "disabled"}`}
                // className={isMobile ? "otp-button" : 
                //   otp.some((digit) => digit === "") ? "otp-button-Desktop-D-popup-disable" : 
                //   signInPopupDesktop ? "otp-button-Desktop-D-popup" : 
                //   "otp-button-Desktop"
                // }
                onClick={handleverifyOtp}
              >
                {isOtpVerificationLoading ? 'Loading...' : (verifyButtonText || 'Sign In')}
              </button>
            </div>
          </form>

        </div>
      </div>
    </>
  );
};

export default OtpScreenNew;
